import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../store/store';
import {
  selectCurrentStep,
  selectFlowSteps,
} from '../store/slices/flow/flowSelectors';
import { setCurrentStep } from '../store/slices/flow/flowSlice';
import usePlaceNavigate from './usePlaceNavigate';

const useFlowNavigationSync = (): void => {
  const dispatch = useAppDispatch();
  const placeNavigate = usePlaceNavigate();
  const { pathname } = useLocation();
  const steps = useSelector(selectFlowSteps);
  const currentStep = useSelector(selectCurrentStep);

  useEffect(() => {
    if (!steps || steps.length === 0) {
      return;
    }

    const segment = pathname.split('/').pop() ?? '';
    const matchedStep = steps.find((s) => s.key === segment);

    if (!matchedStep) {
      return;
    }

    // Forward skip guard: if the user jumped ahead via the browser forward button,
    // redirect to the first step they haven't completed yet.
    if (matchedStep.stepNum > currentStep) {
      const firstIncomplete = steps
        .filter((s) => s.stepNum < matchedStep.stepNum)
        .sort((a, b) => a.stepNum - b.stepNum)
        .find((s) => !s.isCompleted);

      if (firstIncomplete) {
        dispatch(setCurrentStep(firstIncomplete.stepNum));
        placeNavigate('/' + firstIncomplete.key);
        return;
      }
    }

    if (matchedStep.stepNum !== currentStep) {
      dispatch(setCurrentStep(matchedStep.stepNum));
    }
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps
};

export { useFlowNavigationSync };
